import { Component, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { StsNotificationType } from '../../../models/sts-notification-type';
import { Router } from '@angular/router';
import { StsNotification } from '../../../models/sts-notification.model';
import { StsCmsService } from '../../../services/sts-cms-service.service';
import { StsUserService } from '../../../services/sts-user.service';
import StsA360NotificationTokenModel from 'app/models/sts-a360-notification-token.model';

@Component({
  selector: 'account-sel-comm-channel',
  templateUrl: './account-sel-comm-channel.component.html',
  styleUrls: ['./account-sel-comm-channel.component.scss']
})
export class AccountSelCommChannelComponent implements OnInit {
  public errors: StsNotification[] = [];
  public triggerValidateEmitter: EventEmitter<void> = new EventEmitter<void>();
  public submitter: EventEmitter<boolean> = new EventEmitter<boolean>();
  public frmComm: FormGroup;
  communicationChannels: { value: string, text: string }[] = [];
  hasCommunicationChannels: boolean = true;
  message: StsA360NotificationTokenModel;

  constructor(public fb: FormBuilder, private cmsService: StsCmsService, private router: Router, private userService: StsUserService) {
    this.frmComm = this.fb.group(
      { selComm: new FormControl('', { validators: [Validators.minLength(2)], updateOn: 'submit' }) },
      { updateOn: 'submit' }
    );
  }

  ngOnInit() {
    this.userService.getCommunicationChannels().subscribe(result => {
      if (result) {
        result.communicationChannels.forEach(channel => {
          let mask = channel.Type == 'EMAIL' ? this.maskEmail : this.maskPhone;
          this.communicationChannels.push({ value: channel.Value, text: mask(channel.Value) });
        });
      }

      if (this.communicationChannels.length === 0) {
        this.handleNoCommunicationChannels();
      }
    }, _ => {
      this.handleNoCommunicationChannels();
    });

    this.frmComm.controls['selComm'].setValue('0');
  }

  private handleNoCommunicationChannels() {
    this.hasCommunicationChannels = false;
    this.notify('sts-no-communication-channels', StsNotificationType.Error, 'You have no communication channels on file');
  }

  public maskPhone(phone: string): string {
    if (phone == undefined || phone.length == 0)
      return '';
    var replaceWith = 'x';
    var masked = phone.replace(/\d(?!\d{0,3}$)/g, replaceWith);
    return masked;
  }

  public maskEmail(email: string): string {
    if (email == undefined || email.length == 0)
      return '';
    var indat = email.indexOf('@');
    if (indat < 2)
      return '';
    var toreplace = email.substr(1, indat - 1);
    if (toreplace.length < 1)
      return '';
    var replaceWith = '';
    for (var i = 0; i < toreplace.length; i++)
      replaceWith = replaceWith + 'x';

    var masked = email.replace(toreplace, replaceWith);
    return masked;
  }

  public triggerValidation(v) {
    this.frmComm.controls['selComm'].updateValueAndValidity();
  }

  public goHome(): void {
    this.router.navigateByUrl('/');
  }

  isInvalidChoice(): boolean {
    return this.frmComm.controls['selComm'].invalid
      && (this.frmComm.controls['selComm'].dirty || this.frmComm.controls['selComm'].touched);
  }

  goNext(channel: string): void {
    this.router.navigateByUrl('account/2fa/validate/' + channel);
  }

  onSubmitCode(): void {
    this.submitter.emit(false);
    this.triggerValidation('');
    if (this.frmComm.valid) {
      this.submitter.emit(true);

      let channel = (this.frmComm.controls['selComm'].value.indexOf('@') > 0)
        ? 'email'
        : 'phone';

      this.goNext(channel);
    } else {
      this.notify('sts-communication-channel-errors', StsNotificationType.Error, 'Communication channel must be selected');
    }
  }

  notify(code: string, level: StsNotificationType, description: string) {
    let e = new StsNotification();
    e.code = code;
    e.level = level;
    this.cmsService.getText(e.code).subscribe(res => {
      e.description = res ? res : description;
      this.errors = [e];
    });
  }
}
